import Vue from 'vue'
import VueRouter from 'vue-router'

import LayoutDefault from '@/layouts/default/Index.vue'
import LayoutBase from '@/layouts/base/Index.vue'

import SignInView from '../views/sign-in/Index.vue';
import HomeAppBar from '../views/home/AppBar.vue';
import HomeView from '../views/home/Index.vue';
import QRView from '../views/camera_qr/Index.vue';
import QRAppBar from '../views/camera_qr/AppBar.vue';
import CameraView from '../views/camera/Index.vue';
import CameraAppBar from '../views/camera/AppBar.vue';
import ColetaView from '../views/coleta/Index.vue';
import ColetaAppBar from '../views/coleta/AppBar.vue';
import ColetaFilter from '../views/coleta/Filters.vue';
import ColetaCadastroView from '../views/coletacadastro/Index.vue';
import ColetaCadastroAppBar from '../views/coletacadastro/AppBar.vue';
import PrestacaoServicoView from '../views/prestacao_servico/prestacao_servico/Index.vue';
import PrestacaoServicoAppBar from '../views/prestacao_servico/prestacao_servico/AppBar.vue';
import PrestacaoServicoFilter from '../views/prestacao_servico/prestacao_servico/Filters.vue';
import CadastroOSView from '../views/prestacao_servico/cadastroOS/Index.vue';
import CadastroOSAppBar from '../views/prestacao_servico/cadastroOS/AppBar.vue';
import CadastroVeiculoView from '../views/prestacao_servico/cadastroVeiculo/Index.vue';
import CadastroVeiculoAppBar from '../views/prestacao_servico/cadastroVeiculo/AppBar.vue';
import CadastroEquipamentoView from '../views/prestacao_servico/cadastroEquipamento/Index.vue';
import CadastroEquipamentoAppBar from '../views/prestacao_servico/cadastroEquipamento/AppBar.vue';
import CadastroItemView from '../views/prestacao_servico/cadastroItem/Index.vue';
import CadastroItemAppBar from '../views/prestacao_servico/cadastroItem/AppBar.vue';
import ClienteView from '../views/clientes/AppBar.vue';
import ClienteAppBar from '../views/clientes/Index.vue';
import ClienteFilter from '../views/clientes/Filters.vue';
import ProdutoView from '../views/produtos/Index.vue';
import ProdutoAppBar from '../views/produtos/AppBar.vue';
import ProdutoFilter from '../views/produtos/Filters.vue';
import VendedorView from '../views/vendedor/Index.vue';
import VendedorAppBar from '../views/vendedor/AppBar.vue';
import VendedorFilter from '../views/vendedor/Filters.vue';
import FornecedorView from '../views/fornecedor/Index.vue';
import FornecedorAppBar from '../views/fornecedor/AppBar.vue';
import FornecedorFilter from '../views/fornecedor/Filters.vue';
import VeiculoView from '../views/veiculo/Index.vue';
import VeiculoAppBar from '../views/veiculo/AppBar.vue';
import VeiculoFilter from '../views/veiculo/Filters.vue';
import PesquisaMarcaCorView from '../views/PesquisaMarcaCor/Index.vue';
import PesquisaMarcaCorAppBar from '../views/PesquisaMarcaCor/AppBar.vue';

import { ROUTE_SIGN_IN } from '@/constants/ROUTES';
import { TOKENLOCAL } from '@/constants/STORAGE'

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? localStorage.getItem(key) ?? defaultValue;
}

function validaToken(rota, next) {
  const token = getSessionStorage(TOKENLOCAL.tokenlocal);

  if (!token) {
    next({ path: rota });
  } else {
    next();
  }
}

// import BaseLayout from '../layouts/base/Index.vue'

Vue.use(VueRouter)


const routes = [
  {
    path: '/home',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: HomeAppBar,
        default: HomeView,
      },
      name: 'home',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/qr',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: QRAppBar,
        default: QRView,
      },
      name: 'qr',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/camera',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CameraAppBar,
        default: CameraView,
      },
      name: 'camera',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/coleta',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ColetaAppBar,
        filters: ColetaFilter,
        default: ColetaView,
      },
      name: 'coleta-lista',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/coleta/cadastro',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ColetaCadastroAppBar,
        default: ColetaCadastroView,
      },
      name: 'coleta-cadastro',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/prestacao_servico',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PrestacaoServicoAppBar,
        filters: PrestacaoServicoFilter,
        default: PrestacaoServicoView,
      },
      name: 'prestacaoservico',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/cadastroOS',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroOSAppBar,
        default: CadastroOSView,
      },
      name: 'cadastroos',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/cadastroVeiculo',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroVeiculoAppBar,
        default: CadastroVeiculoView,
      },
      name: 'cadastroVeiculo',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/cadastroEquipamento',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroEquipamentoAppBar,
        default: CadastroEquipamentoView,
      },
      name: 'cadastroEquipamento',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/CadastroItem',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: CadastroItemAppBar,
        default: CadastroItemView,
      },
      name: 'CadastroItem',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
    {
    path: '/clientes',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ClienteAppBar,
        filters: ClienteFilter,
        default: ClienteView,
      },
      name: 'clientes',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/produto',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: ProdutoAppBar,
        filters: ProdutoFilter,
        default: ProdutoView,
      },
      name: 'produto',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/vendedor',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: VendedorAppBar,
        filters: VendedorFilter,
        default: VendedorView,
      },
      name: 'vendedor',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/fornecedor',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: FornecedorAppBar,
        filters: FornecedorFilter,
        default: FornecedorView,
      },
      name: 'fornecedor',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/veiculo',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: VeiculoAppBar,
        filters: VeiculoFilter,
        default: VeiculoView,
      },
      name: 'veiculo',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  {
    path: '/pesquisamarcacor',
    component: LayoutDefault,
    children: [{
      components: {
        appBar: PesquisaMarcaCorAppBar,
        default: PesquisaMarcaCorView,
      },
      name: 'pesquisamarcacor',
      path: '',
      beforeEnter: ((to, from, next) => {
        validaToken( ROUTE_SIGN_IN.path, next );
      }),
    }],
  },
  redirectRoute('/'),
  {
    path: '/',
    component: LayoutBase,
    children: [{
      components: {
        default: SignInView,
      },
      name: 'signin',
      path: '',
    }],
  },
  redirectRoute('/'),
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
   scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export function redirectRoute(redirect) {
  return {
    path: '*',
    redirect,
  };
}

export default router

